import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import * as Yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';

// components
import { Grid, DialogContent, DialogActions } from '@mui/material';
import { withStyles } from '@mui/styles';

import { TextFieldBase } from '../../components/inputs/TextFieldBase';
import CBButton from '../../components/Buttons/CbButton';

// utils
import { withFormController } from '../../components/hocs/forms';
import { PubSub } from '../../utils/eventUtils';
import useNotifications from '../../_lib/notifications/useNotifications';

// apis
import { wizerConnect } from './ConnectorService';

const TextField = withFormController(TextFieldBase);
const schema = Yup.object().shape({
  apiKey: Yup.string().required('API Key is required'),
});

const WizerTokenForm = ({ classes, close, data, ...props }: any) => {
  const { cbid } = data;
  const defaultValues = {
    apiKey: '',
  };
  const notifications = useNotifications();

  const { handleSubmit, ...methods } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const {
    getValues,
    formState: { isDirty, isSubmitting },
  } = methods;

  const onSubmit = (formData: any) => {
    const payload = { apiKey: formData.apiKey };
    return wizerConnect({ cbid }, payload)
      .then(() => {
        close();
        PubSub.publish('connector-page-refetch', true);
        notifications.success('Connector added successfully!');
      })
      .catch(() => {
        notifications.error('Failed to add the connector');
      });
  };

  const handleCancel = () => {
    close();
  };

  return (
    <section className={classes.cardContentContainer}>
      <FormProvider {...methods} handleSubmit={handleSubmit}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <p className={classes.description}>
            Get the API Key for your account from
            https://admin.wizer-training.com/
          </p>
          <DialogContent classes={{ root: classes.container }}>
            <Grid
              container
              justifyContent="left"
              className={classes.inputFields}
            >
              <Grid item md={10}>
                <TextField
                  name="apiKey"
                  label="Enter API Key"
                  type="password"
                  fullWidth
                  required
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CBButton action={handleCancel} styleName="cancel">
              Cancel
            </CBButton>
            <CBButton
              type="submit"
              loading={isSubmitting}
              disabled={isSubmitting}
              styleName="ctaButton"
              buttonText="Connect"
            />
          </DialogActions>
        </form>
      </FormProvider>
    </section>
  );
};

const styles = ({ palette }: any) => {
  return {
    description: {
      fontSize: '1.167rem',
      color: palette.primary.main,
      lineHeight: 1.5,
      fontStyle: 'italic',
      textAlign: 'center',
      margin: '0 0 2rem 0 !important',
    },
    container: {
      flex: '1 1 auto',
      padding: '0 5rem 0.5rem 5rem',
      'overflow-y': 'visible',
    },
    inputFields: {
      justifyContent: 'space-around',
    },
  };
};

// @ts-expect-error TS(2345): Argument of type '({ palette }: any) => { descript... Remove this comment to see the full error message
const StyledWizerTokenForm = withStyles(styles)(WizerTokenForm);

export default StyledWizerTokenForm;

export const WizerTokenFormConfig = {
  WizerTokenForm: {
    component: StyledWizerTokenForm,
    config: {
      title: 'Enter Wizer API Key',
      maxWidth: 'md',
    },
  },
};
